<template>
  <Dialog
    v-model="dialog"
    closable
    icon="fas fa-pencil-alt"
    :width="500"
    classBtn="mr-3"
    title="活用編集"
  >
    <template v-slot:content>
      <v-row>
        <v-col cols="3" class="pb-0">
          <label class="font-weight-medium">
            活用名
            <span class="red--text">*</span>
          </label>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            dense
            outlined
            v-model.trim="itemUpdate.name"
            class="pb-0"
            :error-messages="nameErrors"
            @input="$v.itemUpdate.name.$touch()"
            @blur="$v.itemUpdate.name.$touch()"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        :disabled="loading"
        color="primary"
        :loading="loading"
        @click="handleUpdate"
        >{{ $t("UPDATE") }}</v-btn
      >
      <v-btn class="ml-10" @click="handleCancel">{{ $t("CANCEL") }}</v-btn>
      <v-spacer />
    </template>
  </Dialog>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { updatePratice } from "@/api/Pratice.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["item"],
  mixins: [validationMixin],
  components: {
    Dialog,
  },
  validations() {
    return {
      itemUpdate: {
        name: { required },
      },
    };
  },
  data() {
    return {
      loading: false,
      dialog: false,
      itemUpdate: { ...this.item },
    };
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.itemUpdate.name.$dirty) return errors;
      !this.$v.itemUpdate.name.required &&
        errors.push("バッヂ名を入力してください。");
      return errors;
    },
  },
  watch: {
    dialog: function () {
      this.itemUpdate = { ...this.item };
      this.$v.$reset();
    },
  },
  methods: {
    async handleUpdate() {
      this.$v.$touch();
      if (!this.$v.$anyError) {
        this.loading = true;
        const { name, Id } = this.itemUpdate;
        let params = {
          name: name,
          id: Id,
        };
        await updatePratice(params)
          .then(() => {
            this.$emit("resetList");
            this.dialog = false;
            this.loading = false;
          })
          .catch((error) => {
            console.log("error: ", error);
            this.loading = false;
          });
      }
    },
    handleCancel() {
      this.dialog = false;
      this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>